
/**
 * 账户密码输错n次 限制登录 
 * @param {*} vm Vue对象
 * @param {*} count 错误次数
 * @param {*} errTime 限制登录时间
 */
export function LoginErrCountCheck(vm,count,errTime) {
    this.ls = vm.$ls
    this._loginErrCount = count || 3
    this._errTime = errTime || 60000
}

LoginErrCountCheck.prototype.check = function () { // 检查当前状态
    let loginErrCount = this.ls.get('loginErrCount') 
    if(loginErrCount >= this._loginErrCount)
    {
        let loginErrDate = this.ls.get('loginErrDate') 
        let errTime = new Date().getTime() - loginErrDate

        // 限制登录时间1min
        if(errTime < this._errTime)
        {
            return false
        }
        else
        {
            this.clear()
        }
    }

    return true
}

LoginErrCountCheck.prototype.addCount = function () { // 增加错误次数
    let loginErrCount = this.ls.get('loginErrCount') 
    this.ls.set('loginErrCount',loginErrCount + 1) 
    this.ls.set('loginErrDate',new Date().getTime()) 
}

LoginErrCountCheck.prototype.clear = function () { // 清空记录
    this.ls.remove('loginErrCount') 
    this.ls.remove('loginErrDate') 
}


